import { AUTHOR_EVENTS } from '../../../routes/author/services/author-profile-events';
import qualityEventsHelpers from '../quality-events.helpers';

export const AUTHOR_QUALITY_EVENTS = {
    userProfileAction(action: AUTHOR_EVENTS | string) {
        qualityEventsHelpers.track({
            type: 'userProfileAction',
            extra: action
        });
    }
};
